export default __webpack_public_path__ + "static/media/watch-icn.9e20353c.svg";